import { resolver } from '@rocicorp/resolver';
export class Lock {
    _lockP = null;
    async lock() {
        const previous = this._lockP;
        const { promise, resolve } = resolver();
        this._lockP = promise;
        await previous;
        return resolve;
    }
    withLock(f) {
        return run(this.lock(), f);
    }
}
export class RWLock {
    _lock = new Lock();
    _writeP = null;
    _readP = [];
    read() {
        return this._lock.withLock(async () => {
            await this._writeP;
            const { promise, resolve } = resolver();
            this._readP.push(promise);
            return resolve;
        });
    }
    withRead(f) {
        return run(this.read(), f);
    }
    async write() {
        return await this._lock.withLock(async () => {
            await this._writeP;
            await Promise.all(this._readP);
            const { promise, resolve } = resolver();
            this._writeP = promise;
            this._readP = [];
            return resolve;
        });
    }
    withWrite(f) {
        return run(this.write(), f);
    }
}
async function run(p, f) {
    const release = await p;
    try {
        return await f();
    }
    finally {
        release();
    }
}
